// extracted by mini-css-extract-plugin
module.exports = {"crossProductNote":"VerifiedEmail_crossProductNote__2QU4O","noWrap":"VerifiedEmail_noWrap__2k6J7"};